export function replaceHttps(url) {
  if(location.protocol == 'https:') {
    const httpsUrl = url.replace('http:','https:');
    return httpsUrl
  }else {
    return url
  }
}

export function toTime(date) {
  if(date){
    return new Date(date).getTime()
  }else{
    return date
  }
}